// Module
var code = "<div class=\"basket-engraving-popup__preview-rendering-image\"> <div class=\"basket-engraving-popup__preview-text\"> <span class=\"basket-engraving-popup__preview-text-value\"></span> </div> <img class=\"basket-engraving-popup__preview-image\" alt=\"{{productName}}\" title=\"{{productName}}\"/> </div> ";
// Exports
module.exports = code;